import DOMPurify from "dompurify";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import React from "react";
import { Control, useController } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./RichTextInput.scss";

export interface RichTextInputProps {
  name: string;
  control: Control<any>;
  placeholder?: string;
}

const RichTextInput: React.FC<RichTextInputProps> = ({ name, control, placeholder }) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <div
      className="rich-text-input"
      style={{ backgroundColor: "white", borderRadius: "12px" }}
    >
      <ReactQuill
        value={value}
        onChange={(content, delta, source, editor) => {
          onChange(editor.getContents()); // returns Quill Delta
        }}
        theme="snow"
        placeholder={placeholder}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
          ],
        }}
      />
    </div>
  );
};

export default RichTextInput;

export const getDescriptionHtml = (description: any) => {
  try {
    const parsed = JSON.parse(description);
    if (parsed && Array.isArray(parsed.ops)) {
      const converter = new QuillDeltaToHtmlConverter(parsed.ops);
      return DOMPurify.sanitize(converter.convert());
    } else {
      return DOMPurify.sanitize(description).replace(/\n/g, "<br />");
    }
  } catch (e) {
    return DOMPurify.sanitize(description).replace(/\n/g, "<br />");
  }
};
